import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[googleTagManager]'
})
export class GoogleTagManagerDirective implements OnInit {
  @Input() googleTagManager: string[];

  constructor(private elem: ElementRef) {
  }

  ngOnInit() {
    this.googleTagManager.forEach(key => {
      const headHtml = `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${key}');</script>`;

      const bodyHtml = `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${key}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;

      const headFragment = document.createRange().createContextualFragment(headHtml);
      const bodyFragment = document.createRange().createContextualFragment(bodyHtml);

      window.document.head.insertBefore(headFragment, window.document.head.firstChild);
      this.elem.nativeElement.appendChild(bodyFragment);
    });
  }
}
